export const TIER_FEATURES = [
  {
    name: "Free",
    sub_tier: 0,
    features: [
      {
        feature_description: "<b>250MB</b> of Storage (5 Wheel limit)",
        tooltip: false,
      },
      {
        feature_description: "5 Clone limit",
        tooltip: false,
      },
      { feature_description: "Basic Wheel Building features", tooltip: false },
      { feature_description: "Basic Locks", tooltip: false },
      // { feature_description: "No Revenue Generating features", tooltip: false },
    ],
  },
  {
    name: "Essential",
    sub_tier: 1,
    features: [
      {
        feature_description: "<b>500MB</b> of Storage (~20 Wheels/Clones)",
        tooltip: false,
      },

      {
        feature_description: "10 AI Wheel Tokens <b>(per month)</b>",
        tooltip:
          "Build Wheels from a simple Prompt. An average Wheel takes 8 tokens",
      },
      {
        feature_description: "AI Color Generator",
        tooltip:
          "With a simple prompt or image, our generator will design a color theme for your Wheel.",
      },
      { feature_description: "Basic Locks", tooltip: false },
      // { feature_description: "No Revenue Generating features", tooltip: false },
    ],
  },
  {
    name: "Premium",
    sub_tier: 2,
    features: [
      {
        feature_description: "<b>2GBs</b> of Storage (~ 80 Wheels/Clones)",
        tooltip: false,
      },
      {
        feature_description: "50 AI Wheel Tokens <b>(Monthly)</b>",
        tooltip:
          "Build Wheels from a simple Prompt. An average Wheel takes 8 tokens",
      },
      {
        feature_description: "AI Color Generator",
        tooltip:
          "With a simple prompt or image, our generator will design a color theme for your Wheel.",
      },
      {
        feature_description: "Paid Locks <b>(Coming Soon)</b>",
        tooltip: "Charge guests to access your Wheels.",
      },
      // {
      //   feature_description: "Referral Revenue",
      //   tooltip:
      //     "Earn commissions for referring new subscribers. Commission % is based on your subscription level. Premium - 5% ProSuite - 10%",
      // },
      {
        feature_description: "Customizable Ad Space (1)",
        tooltip: "Let your Business Box showcase your products & services",
      },
    ],
  },
  {
    name: "ProSuite",
    sub_tier: 3,
    features: [
      {
        feature_description: "<b>8GBs</b> of Storage (~ 320 Wheels/Clones)",
        tooltip: false,
      },
      {
        feature_description: "200 AI Tokens <b>(Monthly)</b>",
        tooltip:
          "Build Wheels from a simple Prompt. An average Wheel takes 8 tokens",
      },
      {
        feature_description: "AI Color Generator",
        tooltip:
          "With a simple prompt or image, our generator will design a color theme for your Wheel.",
      },
      {
        feature_description: "Paid Locks <b>(Coming Soon)</b>",
        tooltip: "Charge guests to access your Wheels.",
      },
      // {
      //   feature_description: "Referral Revenue",
      //   tooltip:
      //     "Earn commissions for referring new subscribers. Commission % is based on your subscription level. Premium - 5% ProSuite - 10%",
      // },
      {
        feature_description: "Customizable Ad Space (Unlimited)",
        tooltip: "Let your Business Box showcase your products & services",
      },
    ],
  },
];
